/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import { DatalistAnagrafica, Manutenzione } from '@models';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ManutenzioneService } from '@shared/services/manutenzione.service';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { ToolkitGestioneOperaModalManutenzioneComponent } from '../modal-manutenzione/modal-manutenzione.component';

@Component({
    selector: 'app-toolkit-opera-tab-manutenzione',
    templateUrl: './tab-manutenzione.component.html',
})
export class ToolkitGestioneOperaTabManutenzioneComponent implements OnInit{

    @Input() canEdit: boolean;
    @Input() items: Manutenzione[] = [];
    @Input() datalist: DatalistAnagrafica;

    constructor(
        private modalService: NgbModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private manutenzioneService: ManutenzioneService
    ) { }

    ngOnInit(): void {
        this.operaService.manutenzioneByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Manutenzione[]) => {
            this.items = list;
        });        
    }

    
    public viewItem(manutenzione: Manutenzione) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalManutenzioneComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Visualizza';
        modal.componentInstance.datalist = this.datalist;
        this.manutenzioneService.documentoManutenzioneByIdManutenzione(manutenzione.idInterventoManutenzione).subscribe(response => {
            modal.componentInstance.items = response;
        });
        modal.componentInstance.params = manutenzione;
        modal.componentInstance.canEdit = false;
    }

    public addItem() {
        const modal = this.modalService.open(ToolkitGestioneOperaModalManutenzioneComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Aggiungi';
        modal.componentInstance.datalist = this.datalist;
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.insertManutenzione(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.manutenzioneByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Manutenzione[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public editItem(manutenzione: Manutenzione) {
        const modal = this.modalService.open(ToolkitGestioneOperaModalManutenzioneComponent, {size: 'xl'});
        modal.componentInstance.azione = 'Modifica';
        modal.componentInstance.datalist= this.datalist;
        modal.componentInstance.params = manutenzione;
        this.manutenzioneService.documentoManutenzioneByIdManutenzione(manutenzione.idInterventoManutenzione).subscribe(response => {
            modal.componentInstance.items = response;
        });
        modal.componentInstance.canEdit = true;
        modal.result.then(result => {
            if (result) {
                this.operaService.updateManutenzione(result.getRawValue()).subscribe(response => {
                    this.utilsService.showSuccess(CoreI18nConfigs.messages.genericSuccess);
                    this.operaService.manutenzioneByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Manutenzione[]) => {
                        this.items = list;
                    });
                });
            }
        }).catch(e => {});
    }

    public deleteItem(idManutenzione: number) {
        this.operaService.deleteManutenzione(idManutenzione).subscribe(response => {
            if (this.utilsService.genericResponse204NoContent(response)) {
                this.operaService.manutenzioneByIdOpera(this.operaService.operaSession.idOpera).subscribe((list: Manutenzione[]) => {
                    this.items = list;
                });
            }
        });
    }

}
